import { BiContext, ConfigContext, ExperimentsContext, ExternalDataProvider, ForcedStateContext, FormContext, HttpClientContext, TranslationContext, WixRicosViewerContext, AddressFormsContext, getAddressForm, EventsProvider, FieldInitialDataContext, PanoramaContext, FocusedFieldProvider, ScrollProvider, } from '@wix/form-fields';
import React, { useMemo } from 'react';
import { useFormBi } from '../form/use-form-bi';
import { SubmitStatusProvider } from '../../contexts/submit-status-context';
export const FormViewerProvider = ({ i18n, bi, biFormFillSessionId, form, isMobile, isEditor, isComposer, isRTL, compId, locale, regionalFormat, externalData, forcedState, instance, children, httpClient, panorama, experiments, translationNamespace, currency, userData, WixRicosViewer, addressTemplates, atlasBaseUrl, fieldInitialData, enableAnimations, }) => {
    const translations = useMemo(() => ({
        t: i18n.getFixedT(locale, translationNamespace),
        i18n,
    }), [locale, i18n, translationNamespace]);
    const formBi = useFormBi(form, bi, biFormFillSessionId);
    const config = useMemo(() => ({
        locale,
        regionalFormat,
        instance,
        isMobile,
        currency,
        atlasBaseUrl,
        userData,
        compId,
        isEditor,
        isComposer,
        isRTL,
        enableAnimations,
    }), [
        locale,
        regionalFormat,
        instance,
        isMobile,
        currency,
        atlasBaseUrl,
        userData,
        compId,
        isEditor,
        isComposer,
        isRTL,
        enableAnimations,
    ]);
    const forcedViewState = useMemo(() => forcedState ?? [], [forcedState]);
    return (React.createElement(HttpClientContext.Provider, { value: { httpClient } },
        React.createElement(PanoramaContext.Provider, { value: { panorama } },
            React.createElement(TranslationContext.Provider, { value: translations },
                React.createElement(ScrollProvider, null,
                    React.createElement(FocusedFieldProvider, null,
                        React.createElement(FieldInitialDataContext.Provider, { value: fieldInitialData },
                            React.createElement(BiContext.Provider, { value: formBi },
                                React.createElement(ExternalDataProvider, { externalData: externalData },
                                    React.createElement(ConfigContext.Provider, { value: config },
                                        React.createElement(ForcedStateContext.Provider, { value: forcedViewState },
                                            React.createElement(FormContext.Provider, { value: form },
                                                React.createElement(AddressFormsContext.Provider, { value: {
                                                        getCountryAddressForm: (country) => getAddressForm(addressTemplates, country),
                                                        addressTemplates,
                                                    } },
                                                    React.createElement(ExperimentsContext.Provider, { value: experiments },
                                                        React.createElement(EventsProvider, null,
                                                            React.createElement(WixRicosViewerContext.Provider, { value: WixRicosViewer },
                                                                React.createElement(SubmitStatusProvider, null, children)))))))))))))))));
};
//# sourceMappingURL=form-viewer-provider.js.map